/* istanbul ignore file */
import { FetchResponse, ParsedErrorResponse } from 'types/fetch';
import {
  AuthenticateApiRequestPayload,
  AuthenticateApiResponsePayload
} from 'types/visa-sdk/authenticate';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

const RECURSION_FREQUENCY = 5000;
const RECURSION_BREAKDOWN = 12;
export type FetchAuthenticateOptions = {
  accessToken?: string;
  apikey: string;
  requestPayload: AuthenticateApiRequestPayload;
};
export function fetchAuthenticate({
  accessToken,
  apikey,
  requestPayload
}: FetchAuthenticateOptions): FetchResponse<AuthenticateApiResponsePayload, ParsedErrorResponse> {
  const url = `${endpoints.authenticate}?apikey=${apikey}`;
  return fetchReq({
    body: requestPayload,
    headers: {
      access_token: accessToken
    },
    mark: 'authenticate',
    method: 'POST',
    url
  }).then(res => {
    return res;
  });
}

export async function fetchAuthenticateResults({
  accessToken,
  apikey,
  requestPayload
}: FetchAuthenticateOptions): Promise<
  FetchResponse<AuthenticateApiResponsePayload, ParsedErrorResponse>
> {
  return new Promise(resolve => {
    let retryCount = 0;

    async function fetchResults(): Promise<unknown> {
      const url = `${endpoints.authenticate}?apikey=${apikey}`;
      const res = await fetchReq({
        body: requestPayload,
        headers: {
          access_token: accessToken
        },
        mark: 'authenticate',
        method: 'POST',
        url
      });

      const xAppStatus = res.headers['x-app-status'];

      if (xAppStatus === '202') {
        if (retryCount >= RECURSION_BREAKDOWN) {
          return resolve(res);
        }

        retryCount++;
        return setTimeout(fetchResults, RECURSION_FREQUENCY);
      }

      return resolve(res);
    }

    return fetchResults();
  });
}
